"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var component_1 = require("./");

var TensorTComponentClass =
/** @class */
function (_super) {
  __extends(TensorTComponentClass, _super);

  function TensorTComponentClass(props) {
    var _this = _super.call(this, props) || this;

    _this.canvasContext = null;
    return _this;
  }

  TensorTComponentClass.prototype.render = function () {
    var pointsToPlot = this.props.pointsToPlot;
    return React.createElement(component_1.PlotlyChart, {
      data: pointsToPlot,
      layout: __assign({}, component_1.defaultPlotlyLayout, {
        dragmode: 'select',
        margin: {
          b: 20
        },
        xaxis: {
          autorange: false,
          range: [0, 1],
          showline: true
        },
        yaxis: {
          autorange: false,
          range: [0, 1],
          showline: true
        }
      }),
      onSelectedCallback: this.props.onSelectedCallback
    });
  };

  TensorTComponentClass.defaultProps = {
    pointsToPlot: [],
    style: {
      padding: 0
    }
  };
  return TensorTComponentClass;
}(React.Component);

exports.TensorTComponent = function (props) {
  return React.createElement(TensorTComponentClass, __assign({}, props));
};